import React from 'react';
import FormatSelect from './FormatSelect';
import { MenuBar, MenuItemList, MenuItem } from '../baseComponents';

function menuItemGroups(items) {
  const blockFormatting = ['p', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
  const marks = ['b', 'i', 'strike', 'underline', 'superscript'];
  const actions = ['undo', 'redo'];
  const wraps = ['UL', 'OL', 'blockquote'];
  const media = ['iframe', 'link', 'image'];
  const clear = ['clearFormatting'];

  const sortedItems = menuItems =>
    items
      .filter(function(item) {
        return menuItems.indexOf(item.name) !== -1;
      })
      .sort((a, b) => menuItems.indexOf(a.name) - menuItems.indexOf(b.name));

  return {
    blockFormatting: sortedItems(blockFormatting),
    marks: sortedItems(marks),
    actions: sortedItems(actions),
    wraps: sortedItems(wraps),
    media: sortedItems(media),
    clear: sortedItems(clear)
  };
}

function Menu({ items }) {
  const itemGroups = menuItemGroups(items);
  return (
    <MenuBar id="editor-ui-menu-bar">
      <MenuItemList divider>
        {itemGroups.actions.map((item) => (
          <MenuItem {...item} key={item.name} />
        ))}
      </MenuItemList>
      <MenuItemList divider>
        <FormatSelect options={itemGroups.blockFormatting} />
      </MenuItemList>
      <MenuItemList divider>
        {itemGroups.marks.map((item) => (
          <MenuItem {...item} key={item.name} />
        ))}
      </MenuItemList>
      <MenuItemList divider>
        {itemGroups.clear.map((item) => (
          <MenuItem {...item} key={item.name} />
        ))}
      </MenuItemList>
      <MenuItemList>
        {itemGroups.wraps.map((item) => (
          <MenuItem {...item} key={item.name} />
        ))}
      </MenuItemList>
      <MenuItemList divider>
        {itemGroups.media.map((item) => (
          <MenuItem {...item} key={item.name} />
        ))}
      </MenuItemList>
    </MenuBar>
  );
}

export default Menu;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/topMenu/index.jsx